import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class UiRouteService {
    constructor(public router: Router, public route: ActivatedRoute) {}

    public navigateToRelative(route: string) {
        const url = this.router.url + '/' + route;
        this.router.navigateByUrl(url);
    }

    public navigateBack() {
        this.router.navigate(['..'], { relativeTo: this.route });
    }

    public navigateTo(path: string) {
        this.router.navigate([path], { relativeTo: this.route });
    }
}
